import { atomWithQuery } from "jotai-tanstack-query";
import { atom } from "jotai";
import { authAtom } from "../../auth/atoms";
import { SearchApiParams } from "../../../types/search";
import { loadLocations } from "../../../apis/search";

export const venueSearchParamsAtom = atom<SearchApiParams>({
  search: "",
  latitude: null,
  longitude: null,
  userlatitude: null,
  userlongitude: null,
  types: "",
  accessibilities: "",
  showVenueOptions: "All",
  addinfo: "",
  placesToReplaceString: "",
  searchThisAreaClicked: "no",
  zoom: "15",
  new_map: "1",
  tagging_mode: "off",
  progressive_update: "yes",
  userToken: "",
  saved_place_id: "",
  saved_place_user_id: "",
  saved_place_sortby: "",
  unixTimestamp: Math.floor(Date.now() / 1000), // Add unixTimestamp here
});

export const homePinsAtom = atomWithQuery((get) => ({
  queryKey: [
    "homePins",
    get(venueSearchParamsAtom),
    get(authAtom)?.data?.accessToken,
  ],
  queryFn: async ({ queryKey: [, params, accessToken] }) => {
    const parameters = params as SearchApiParams;
    //const user = get(authAtom)?.data;
    if (parameters.latitude === null || parameters.longitude === null) {
      console.log("No user location, not loading pins");
      return {
        locations: [],
        accessibility_tags: [],
        newRegion: null,
        newLocation: null,
      };
    }
    console.log(
      "Loading pins",
      parameters.types,
      parameters.latitude,
      parameters.longitude,
      parameters.userlatitude,
      parameters.userlongitude
    );
    const response = await loadLocations(
      accessToken as unknown as string | null | undefined,
      parameters
    );

    const selectedVenueTypes = parameters.types.split("|");
    if (selectedVenueTypes.length <= 0) {
      return response;
    }

    const locations = response.locations.map((location) => {
      const types = location.types.split("|");
      for (const type of selectedVenueTypes) {
        if (types.includes(type.toLowerCase())) {
          //console.log("Found type, changing", type, location.businessType);
          return {
            ...location,
            calcVenueType: type,
          };
        }
      }
      //find this
      // console.log(
      //   "No type found, keeping",
      //   location.businessType,
      //   location.name,
      //   location.types
      // );
      return {
        ...location,
      };
    });
    return {
      locations: locations,
      accessibility_tags: response.accessibility_tags,
      newRegion: response.newRegion,
      newLocation: response.newLocation,
    };
  },
}));

export const accessibilityTagsAtom = atom<any[]>((get) => {
  const data = get(homePinsAtom);
  return data?.data?.accessibility_tags || [];
});
